/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import transliterate from '../transliterate';

/**
 * Generates an ID from the given input string.
 *
 * @param {string} inputString - The input string to generate the ID from.
 * @returns {string} The generated ID.
 */
export default function generateIdFromContext(inputString) {
  // Split the input string into words
  let words = inputString.split(/\s+/);

  // Use only the first 3 words, or less if the string has less than 3 words
  words = words.slice(0, 3);

  // Transliterate the new string to remove diacritics and special characters
  words = words.map(word => transliterate(word, { removeSpecialCharacters: true }));

  // Convert the words to camel case
  let context = words.map((word, index) => {
    return index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join('');

  // Generate a random 5 character alphanumeric string
  let randomStr = Math.random().toString(36).substring(2, 7);

  // Combine the context and the random string with a "_"
  return `${context}_${randomStr}`;
}
